import { z } from 'zod';

import { optionalString } from '@/shared/utils/validation';

export const selectSecretInputSchema = z.object({
  vaultId: optionalString(),
  secretId: optionalString(),
});
